import * as Yup from 'yup';

import { YZip } from 'utils/YupUtils';

export const YExpertSearchDialog = Yup.object().shape({
  zip: YZip.required('PLZ ist erforderlich'),
});
